import React from 'react';
import { ChevronDown } from 'lucide-react';
import { coLearningInkBody, coLearningInkTitle } from '../ui/coLearningModalTheme';

/**
 * Premium accordion section — matches Artist Salon / Re-imagined insight cards.
 */
export default function PremiumAccordion({ title, isOpen, onToggle, children, className = '' }) {
  return (
    <div
      className={`overflow-hidden rounded-2xl border border-[#F5D99B]/70 bg-gradient-to-br from-[#FFFDF9] to-[#FFF5E8] shadow-[0_6px_18px_rgba(120,72,20,0.06)] ${className}`}
    >
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left transition hover:bg-[#FFF9EF]/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F59E0B]/30 sm:px-5 sm:py-4"
      >
        <h3 className={`text-sm font-semibold sm:text-base ${coLearningInkTitle}`}>{title}</h3>
        <ChevronDown
          className={`h-4 w-4 shrink-0 text-[#B45309] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          strokeWidth={2.25}
          aria-hidden
        />
      </button>
      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-out ${
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <div className={`border-t border-[#F5D99B]/50 bg-white/60 px-4 py-3.5 sm:px-5 sm:pb-5 ${coLearningInkBody}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
